<template>
  <div class="cell">
    <div class="cell-label" :style="{ width: `${ labelWidth }px` }">{{ label }}</div>
    <div class="cell-content">
      <slot />
    </div>
  </div>
</template>

<script>
export default {

  props: {
    label: String,
    labelWidth: {
      type: Number,
      default: 87
    }
  },
  data() {
    return {

    }
  }
}
</script>

<style lang='scss' scoped>
.cell {
    display: flex;
    line-height: 26px;
    + .cell {
        margin: 30px 0 0;
    }
    .cell-label {
        flex-shrink: 0;
        width: 87px;
        color: #999;
    }
    .cell-content {
        flex: 1;
        white-space: pre-wrap;
    }
}
</style>
